<template>
  <router-view :customCompanyId="companyId"></router-view>
</template>

<script>
import _ from 'lodash'
import { ROOT_COMPANY_ID } from '@/constant/company'
import { msdMobileJobListRouteMap } from './route'

export default {
  components: {

  },
  data () {
    return {
      companyId: ROOT_COMPANY_ID.MSD
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    const pathReg = /^\/msdchina\/professionals\/.*/
    if (pathReg.test(to.path)) {
      const route = _.get(msdMobileJobListRouteMap, to.meta?.customCompanyId)
      let hashStr = ''
      if (to.hash) {
        hashStr = `${to.hash.replace('#', '')}`
      }
      if (route.meta.defaultCustomFilterName) {
        hashStr = `${hashStr}${hashStr ? '&' : ''}${route.meta.defaultCustomFilterName}`
      }
      if (hashStr) {
        hashStr = `#${hashStr}`
      }
      next({ path: '/msdchina/professionals', query: to.query, hash: hashStr })
    }
    next()
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
</style>
